import { z } from "zod";

export const attachmentMetaSchema = z.object({
  targetType: z.enum(["asset", "request", "license", "maintenance", "label", "other"]),
  targetId: z.string().trim().min(1, "请选择关联对象").max(100),
  category: z.string().trim().max(40).optional().nullable(),
});

export type AttachmentMetaInput = z.infer<typeof attachmentMetaSchema>;
